// Convert any date to IST
export const toIST = (date) => {
  const utcMillis = date.getTime() + date.getTimezoneOffset() * 60000; // local -> UTC
  return new Date(utcMillis  + (5.5 * 60 * 60 * 1000)); // IST = UTC + 5h30
};

// Calculate available slots based on order creation time
export const getAvailableDeliverySlots = (orderCreatedAt) => {
  const createdIST = toIST(new Date(orderCreatedAt));
  const nowIST = toIST(new Date());

  // cutoff: 1 hour after order creation
  const cutoffIST = new Date(createdIST.getTime() + 60 * 60 * 1000);
  if (nowIST > cutoffIST) {
    return [];
  }

  const createdHour = createdIST.getHours();
  const slots = [];

  if (createdHour < 12) {
    // Before noon → default today 6–8 PM
    slots.push({ dayOffset: 0, slot: "6 PM - 8 PM" });
    slots.push({ dayOffset: 0, slot: "8 PM - 10 PM" });
    slots.push({ dayOffset: 1, slot: "2 PM - 4 PM" });
    slots.push({ dayOffset: 1, slot: "4 PM - 6 PM" });
    slots.push({ dayOffset: 1, slot: "6 PM - 8 PM" });
    slots.push({ dayOffset: 1, slot: "8 PM - 10 PM" });
  } else {
    // After noon → default tomorrow 2–4 PM
    slots.push({ dayOffset: 1, slot: "2 PM - 4 PM" });
    slots.push({ dayOffset: 1, slot: "4 PM - 6 PM" });
    slots.push({ dayOffset: 1, slot: "6 PM - 8 PM" });
    slots.push({ dayOffset: 1, slot: "8 PM - 10 PM" });
  }

  return slots;
};

// Helper: turn dayOffset into "Today" or "Tomorrow" dynamically
// Helper: turn dayOffset into "Today" or "Tomorrow" with weekday and date
export const getDayLabel = (dayOffset) => {
  const nowIST = toIST(new Date());

  const date = new Date(nowIST);
  date.setDate(nowIST.getDate() + dayOffset);

  const todayDate = nowIST.toDateString();
  const tomorrowDate = new Date(nowIST);
  tomorrowDate.setDate(nowIST.getDate() + 1);

  const weekday = date.toLocaleDateString("en-IN", {
    weekday: "long",
    timeZone: "Asia/Kolkata",
  });
  const formattedDate = date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    timeZone: "Asia/Kolkata",
  });

  if (date.toDateString() === todayDate) {
    return `Today (${weekday}, ${formattedDate})`;
  }
  if (date.toDateString() === tomorrowDate.toDateString()) {
    return `Tomorrow (${weekday}, ${formattedDate})`;
  }

  // fallback for >1 day offsets
  return `${weekday}, ${formattedDate}`;
};

export const dateFormatter = (date) => {

  const dateConv = new Date(date);

  const weekday = dateConv.toLocaleDateString("en-IN", {
    weekday: "long",
    timeZone: "Asia/Kolkata",
  });

  const formattedDate = dateConv.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true, 
    timeZone: "Asia/Kolkata",
  });

  return `${weekday} at ${formattedDate}`;
};

export const dateFormatterIST = (date) => {

  const dateConv = new Date(date);

  const formattedDate = dateConv.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
    timeZone: "Asia/Kolkata",
  });

  return `${formattedDate}`;
};

// A stable YYYY-MM-DD key in IST for safe "same calendar day" comparisons
export const istDateKey = (date) => {
  const dIST = toIST(new Date(date));
  const y = dIST.getFullYear();
  const m = String(dIST.getMonth() + 1).padStart(2, '0');
  const d = String(dIST.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

// Add N days relative to a base date in IST (returns a JS Date)
export const addDaysIST = (baseDate, days) => {
  const baseIST = toIST(new Date(baseDate));
  const out = new Date(baseIST);
  out.setDate(baseIST.getDate() + Number(days));
  return out;
};

export const dateFormatterShort = (date) => {

  const dateConv = new Date(date);

  const formattedDate = dateConv.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric", 
    timeZone: "Asia/Kolkata",
  });

  return `${formattedDate}`;
};

export const dateFormatterShortWeekDay = (date) => {

  const dateConv = new Date(date);

  const weekday = dateConv.toLocaleDateString("en-IN", {
    weekday: "long",
    timeZone: "Asia/Kolkata",
  });

  const formattedDate = dateConv.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric", 
    timeZone: "Asia/Kolkata",
  });

  return `${weekday}, ${formattedDate}`;
};

export const slotStartHour = (slot) => {
  // expected formats: "6 PM - 8 PM", "2 PM - 4 PM", "8 AM - 10 AM", etc.
  const parts = slot.split('-')[0].trim().split(' '); // ["6","PM"]
  let hour = Number(parts[0]);
  const ampm = parts[1]?.toUpperCase();

  if (ampm === 'PM' && hour !== 12) hour += 12;
  if (ampm === 'AM' && hour === 12) hour = 0;
  return hour;
};

export const buildSlotStartIST = (dayDateIST, slot) => {
  // clone dayDateIST to avoid mutating
  const d = new Date(dayDateIST.getTime());
  const hour = slotStartHour(slot);
  d.setHours(hour, 0, 0, 0);
  return d;
};